'use client'

import { Button } from '@/components/ui/button' // hoặc bạn dùng nút thường cũng được
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { sanitize } from '@/lib/helpers/sanitize'
import { cn } from '@/lib/utils'
import { useEffect, useRef, useState } from 'react'

interface CollectionSeoContentProps {
  htmlContent: string
  className?: string
}

export const CollectionSeoContent = ({
  htmlContent,
  className,
}: CollectionSeoContentProps) => {
  const [expanded, setExpanded] = useState(false)
  const [showToggle, setShowToggle] = useState(false)
  const [maxHeight, setMaxHeight] = useState('0px')
  const contentRef = useRef<HTMLDivElement>(null)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const isMobile = useIsMobileClient()

  useEffect(() => {
    const el = contentRef.current
    if (!el) return

    const fullHeight = el.scrollHeight
    const initHeight = isMobile ? 250 : 200

    // Chỉ hiện nút toggle nếu nội dung đủ dài
    setShowToggle(fullHeight > initHeight)

    // Chỉ set max-height khi thu gọn, khi mở rộng để auto
    setMaxHeight(expanded ? 'none' : `${initHeight}px`)
  }, [htmlContent, expanded, isMobile])

  const scrollWithOffset = () => {
    const offset = 200

    const top = wrapperRef.current?.getBoundingClientRect().top ?? 0
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    window.scrollTo({
      top: top + scrollTop - offset,
      behavior: 'smooth',
    })
  }

  const handleToggle = () => {
    if (expanded && wrapperRef.current) {
      scrollWithOffset()
      setTimeout(() => {
        setExpanded(false)
      }, 260)
    } else {
      setExpanded(true)
    }
  }

  return (
    <div
      className={cn(
        'relative mb-10 mt-6 bg-neutral-100 text-sm lg:mt-[74px]',
        className
      )}
      ref={wrapperRef}
    >
      <div
        className={`relative mx-auto max-w-7xl overflow-hidden px-6 py-2 ${expanded ? '' : 'transition-[max-height] duration-500 ease-in-out'}`}
        style={{ maxHeight }}
      >
        <div
          ref={contentRef}
          className='rich-html w-full'
          dangerouslySetInnerHTML={{ __html: sanitize(htmlContent) }}
        />
        {!expanded && showToggle && (
          <div
            className='pointer-events-none absolute bottom-0 left-0 right-0 h-full'
            style={{
              background:
                'linear-gradient(180deg, rgba(242, 242, 242, 0) -28.68%, #F2F2F2 70.51%)',
            }}
          />
        )}
        {showToggle && (
          <div
            className={
              expanded ? 'sticky bottom-4 z-[1]' : 'absolute bottom-4 left-4'
            }
          >
            <div className='text-center'>
              <Button
                variant='outline-neutral'
                onClick={handleToggle}
                className='text-sm'
              >
                {expanded ? 'Thu gọn' : 'Xem thêm'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
